import type * as lazyIndex from './lazyIndex';
import { LazyAction, LazyModule } from 'owa-bundling-light';

const lazyModule: LazyModule<typeof lazyIndex> = new LazyModule<typeof lazyIndex>(
    () => import(/* webpackChunkName: "UserConfiguration"*/ './lazyIndex'),
    { name: 'UserConfiguration' }
);

export const lazyUpdateUserConfigurationOperation: LazyAction<
    typeof lazyIndex.updateUserConfigurationOperation,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.updateUserConfigurationOperation);

export const lazySetMailboxMessageConfiguration: LazyAction<
    typeof lazyIndex.setMailboxMessageConfiguration,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.setMailboxMessageConfiguration);

export const lazySetUserTheme: LazyAction<typeof lazyIndex.setUserTheme, typeof lazyModule> =
    new LazyAction(lazyModule, m => m.setUserTheme);
